import { useDocumentTags } from './use-document-tags'

export function useDocumentExtractedCarcRarcData({ documentKey }: { documentKey: string }) {
  const { data } = useDocumentTags({ documentKey })

  return {
    data: data.items.filter((item) => item.type === 'carc-rarc')[0],
  }
}
